export const replaceBase64ImageString = (origin = '') => {
  const re = /^data:image\/\w+;base64,/;
  const newString = origin.trim().replace(re, '');
  return newString;
};

export const parseBanner = (origin) => {
  return {
    img: origin.picture_url,
    link: origin.website_url,
  };
};

export const parseNews = (origin) => {
  const label = origin.news_type;

  const important = label === '重要';
  const maintain = label === '維修';
  const emergency = label === '緊急';

  return {
    tag: { important, maintain, emergency },
    title: origin.content,
    date: origin.update_date,
    label,
    link: '',
  };
};

export const parseMember = (origin) => {
  return {
    id: origin.member_id,
    accountCode: origin.account_code,
    abbreviation: origin.abbreviation,
    title: origin.mandarin_name,
    paymentType: origin.payment_method_name,
  };
};

export const parseOrderRecord = (origin) => {
  return {
    orderID: origin.order_id,
    rating: origin.comment_stars,
    orderInfo: origin.delivery_and_payment,
    isCommented: origin.is_comment,
    isPrinted: origin.is_print,
    memberInfo: origin.member_info,
    orderStatus: origin.order_info,
    receiver: origin.receiver,
    sender: origin.sender,
    isShowReassign: origin.is_show_reassign,
    isShowStay: origin.is_show_stay,
  };
};

export const parseMonthFeeSettingList = (origin) => {
  return {
    activityName: origin.activity_name,
    activityCode: origin.activity_code,
    settingsDate: origin.settings_date,
    startDate: origin.start_date,
    endDate: origin.end_date,
    upStandardFee: origin.up_standard_fee,
    notUpStandardFee: origin.not_up_standard_fee,
    lastEdit: origin.last_edit,
    activityId: origin.activity_id,
    isShowDelete: origin.is_show_delete,
  };
};

export const parseOrderStatusLog = (origin) => {
  return {
    orderID: origin.order_id,
    orderStatus: origin.order_status,
    timeStamp: origin.time_stamp,
    courier: origin.courier,
    courierPhone: origin.courier_phone,
    remarks: origin.remarks,
  };
};

export const parseOrderComment = (origin) => {
  return {
    id: origin.id,
    orderID: origin.order_id,
    rating: origin.comment_stars,
    commentText: origin.comment_text,
    pictureString: origin.picture_string,
    pictureName: origin.picture_name,
    editTimes: origin.modification_times,
  };
};

export const parseHomepagePictureConfig = (origin) => {
  return {
    id: origin.id,
    activityName: origin.activity_name,
    connectedWebsite: origin.connected_website,
    pictureName: origin.picture_name,
    display: origin.display,
    pictureString: origin.picture_string,
  };
};

export const decodeHomepagePictureConfig = (origin) => {
  return {
    id: origin.id,
    activity_name: origin.title,
    connected_website: origin.link,
    picture_name: origin.pictureName,
    picture_string: replaceBase64ImageString(origin.pictureString),
    display: origin.display,
  };
};

export const parseContact = (origin) => {
  return {
    id: String(origin.id),
    main: origin.is_main_contact,
    isOwner: origin.is_owner,
    name: origin.name,
    company: origin.company,
    cell: origin.phone,
    tel: origin.second_phone || origin.phone,
    department: origin.department,
    address: origin.address,
    remark: origin.remark,
  };
};

export const parseNewsConfig = (origin) => {
  return {
    id: origin.id,
    order: origin.id,
    typeName: origin.news_type_name,
    type: origin.news_type,
    content: origin.content,
    display: origin.display,
  };
};

export const parseMemberDetail = (origin) => {
  return {
    id: origin.member_id,
    abbreviation: origin.member.abbreviation || '',
    account_code: origin.member.account_code || '',
    member_type: origin.member.member_type || '',
    member_type_code: origin.member.member_type_code || '',
    industry_type_code: origin.member.industry_type_code || '',
    industry_type_name: origin.member.industry_type_name || '',
    company_name: origin.member.company_name || '',
    owner: origin.member.owner || '',
    payment_method: origin.payment.payment_method.toString() || '',
    paymentCondition: origin.payment.payment_method_name || '',
    city: origin.member.city_name || '',
    district: origin.member.district_name || '',
    districtID: origin.member.district_id || '',
    address: origin.member.street_address || '',
    website: origin.member.website || '',
    email: origin.member.email || '',
    password: origin.member.password || '',
    areaCode: origin.member.phone_number_city_code || '',
    telPhone: origin.member.phone_number || '',
    extensionNumber: origin.member.phone_number_ext || '',
    mobile: origin.member.mobile_phone_number || '',
    remark: origin.member.note || '',
    accountingInCharge: origin.payment.responsible_accountant || '',
    accountReceivable: origin.payment.receivable_category || '',
    disscount: origin.payment.discount_amount || '',
    taxNumber: origin.payment.tax_id || '',
    shippingRateListID: origin.payment.shipping_rate_list_id.toString() || '',
    shippingRateListName: origin.payment.shipping_rate_list_name || '',
    requestDate: origin.payment.invoice_date || '',
    checkoutDate: origin.payment.settlement_date || '',
    bankSwiftCode: origin.payment.bank_swift_code || '',
    bankName: origin.payment.bank_name || '',
    bankCode: origin.payment.bank_swift_code || '',
    bankAccount: origin.payment.bank_account || '',
    matchMonthlyFee: undefined,
    preOrder: undefined,
    avalidPoint: origin.payment.avalid_point || 0,
    feeMonthly: origin.payment.fee_monthly || '',
    reference: origin.payment.reference || [],
  };
};

export const parseOrderInfo = (origin) => {
  return {
    memberID: origin.member_id,
    accountCode: origin.account_code,
    name: origin.responsible_accountant,
    abbreviation: origin.abbreviation,
    mandarinName: origin.mandarin_name,
    paymentType: origin.payment_method_name,
  };
};

export const parseCreateOrderDefault = (origin) => {
  if (!(origin && origin.top_data && origin.sender_data)) return false;

  const topData = {
    accountCode: origin.top_data.account_code,
    mandarinName: origin.top_data.mandarin_name,
    name: origin.top_data.name,
    tel: origin.top_data.tel,
    paymentType: origin.top_data.payment_type,
  };

  const senderData = {
    contactID: origin.sender_data.contact_id,
    company: origin.sender_data.company,
    contact: origin.sender_data.contact,
    phoneAreaCode: origin.sender_data.phone_area_code,
    phone: origin.sender_data.phone,
    phoneExt: origin.sender_data.phone_ext,
    mobile: origin.sender_data.mobile,
    isMobilePhone: origin.sender_data.is_mobile_phone,
    districtID: origin.sender_data.district_id,
    address: origin.sender_data.address,
    districtName: origin.sender_data.district_name,
    cityName: origin.sender_data.city_name,
    pickUpTime: origin.sender_data.pick_up_time,
  };

  return { topData, senderData };
};

export const parseCreateOrderDefaultTwo = (origin) => {
  if (!(origin && origin.top_data && origin.receiver_data && origin.delivery))
    return false;

  const topData = {
    accountCode: origin.top_data.account_code,
    mandarinName: origin.top_data.mandarin_name,
    name: origin.top_data.name,
    tel: origin.top_data.tel,
    paymentType: origin.top_data.payment_type,
  };

  const receiverData = {
    contactID: origin.receiver_data.contact_id,
    company: origin.receiver_data.company,
    contact: origin.receiver_data.contact,
    phoneAreaCode: origin.receiver_data.phone_area_code,
    phone: origin.receiver_data.phone_number,
    phoneExt: origin.receiver_data.phone_ext,
    mobile: origin.receiver_data.mobile,
    isMobilePhone: origin.receiver_data.is_mobile,
    districtID: origin.receiver_data.district_id,
    address: origin.receiver_data.address,
    districtName: origin.receiver_data.district_name,
    cityName: origin.receiver_data.city_name,
    receiveTime: origin.receiver_data.receive_time,
    deliveryMethod: origin.receiver_data.delivery_method,
    deliveryMethodName: origin.receiver_data.delivery_method_name,
  };

  const delivery = origin.delivery;
  const contactDirectory = [];

  for (const directory of origin.contact_directory) {
    contactDirectory.push({
      contactID: directory.contact_id,
      company: directory.company,
      contact: directory.contact,
      phoneAreaCode: directory.phone_area_code,
      phone: directory.phone_number,
      phoneExt: directory.phone_ext,
      mobile: directory.mobile,
      isMobilePhone: directory.is_mobile,
      districtID: directory.district_id,
      address: directory.address,
      districtName: directory.district_name,
      cityName: directory.city_name,
    });
  }

  return { topData, receiverData, delivery, contactDirectory };
};

export const parseCreateOrderDefaultThree = (origin) => {
  if (
    !(
      origin &&
      origin.top_data &&
      origin.delivery_note_data &&
      origin.payment_method_options &&
      origin.invoice_payment_method_type &&
      origin.weight_options &&
      origin.cbm_options &&
      origin.delivery_note_options
    )
  )
    return false;

  const topData = {
    accountCode: origin.top_data.account_code,
    mandarinName: origin.top_data.mandarin_name,
    name: origin.top_data.name,
    tel: origin.top_data.tel,
    paymentType: origin.top_data.payment_type,
  };

  const deliveryNoteData = {
    createDate: origin.delivery_note_data.create_date,
    companyEmail: origin.delivery_note_data.company_email,
    personalEmail: origin.delivery_note_data.personal_email,
    specialSubAccount: origin.delivery_note_data.special_sub_account,
    paymentMethodID: origin.delivery_note_data.payment_method_id,
    taxID: origin.delivery_note_data.tax_id,
    mandarinName: origin.delivery_note_data.mandarin_name,
    invoiceType: origin.delivery_note_data.invoice_type,
    agencyReceiptAmount: origin.delivery_note_data.agency_receipt_amount,
    prePaidAmount: origin.delivery_note_data.pre_paid_amount,
    insuranceAmount: origin.delivery_note_data.insurance_amount,
    weightID: origin.delivery_note_data.weight_id,
    cbmID: origin.delivery_note_data.cbm_id,
    productPrice: origin.delivery_note_data.product_price,
    deliveryNote: origin.delivery_note_data.delivery_note,
    shippingFee: origin.delivery_note_data.shipping_fee,
    tax: origin.delivery_note_data.tax,
    total: origin.delivery_note_data.total,
  };

  const paymentMethodOptions = origin.payment_method_options;
  const invoicePaymentMethodType = origin.invoice_payment_method_type;
  const weightOptions = origin.weight_options;
  const cbmOptions = origin.cbm_options;
  const deliveryNoteOptions = origin.delivery_note_options;

  return {
    topData,
    deliveryNoteData,
    paymentMethodOptions,
    invoicePaymentMethodType,
    weightOptions,
    cbmOptions,
    deliveryNoteOptions,
  };
};

export const parseCreateOrderDefaultFour = (origin) => {
  if (!(origin && origin.top_data && origin.order_data)) return false;

  const topData = {
    accountCode: origin.top_data.account_code,
    mandarinName: origin.top_data.mandarin_name,
    name: origin.top_data.name,
    tel: origin.top_data.tel,
    paymentType: origin.top_data.payment_type,
  };

  const orderData = {
    orderNumber: origin.order_data.order_no,
    createDate: origin.order_data.create_date,
    senderAccountCode: origin.order_data.sender_account_code,
    agencyReciptAmount: origin.order_data.agency_recipt_amount,
    prePaidAmount: origin.order_data.pre_paid_amount,
    senderCompany: origin.order_data.sender_company,
    senderContactName: origin.order_data.sender_contact_name,
    senderPhone: origin.order_data.sender_phone,
    senderFullAddress: origin.order_data.sender_full_address,
    senderServiceArea: origin.order_data.sender_service_area,
    receiverCompany: origin.order_data.receiver_company,
    receiverContactName: origin.order_data.receiver_contact_name,
    receiverPhone: origin.order_data.receiver_phone,
    receiverFullAddress: origin.order_data.receiver_full_address,
    receiverServiceArea: origin.order_data.receiver_service_area,
    shippingFee: origin.order_data.shipping_fee,
    cbm: origin.order_data.cbm,
    deliveryNote: origin.order_data.delivery_note,
    deliveryMethod: origin.order_data.delivery_method,
  };

  return {
    topData,
    orderData,
  };
};

export const parseServiceArea = (origin) => {
  return {
    value: origin.service_area_id,
    text: origin.name,
    serviceAreaID: origin.service_area_id,
  };
};

export const parseContactDetail = (origin) => {
  return {
    id: origin.id,
    name: origin.name,
    email: origin.email,
    phone: origin.phone,
    secondPhone: origin.second_phone,
    department: origin.department,
    note: origin.note,
    company: origin.company,
    isMainContact: origin.is_main_contact,
    isEmployee: origin.is_employee,
    memberAbbrev: origin.member_abbrev,
    streetAddress: origin.street_address,
    cityName: origin.city_name,
    districtName: origin.district_name,
    districtID: origin.district_id,
    serviceAreaID: origin.service_area_id,
    defaultMemberID: origin.member_id,
  };
};

export const parsePreorderList = (origin) => {
  return {
    orderStatus: origin.status,
    memberInfo: origin.member_info,
    receiver: origin.receiver,
    sender: origin.sender,
    orderInfo: origin.order_info,
  };
};

export const parseOrderContact = (origin) => {
  return {
    contactID: origin.contact_id,
    company: origin.company,
    contact: origin.contact,
    phoneAreaCode: origin.phone_area_code,
    phone: origin.phone_number,
    phoneExt: origin.phone_ext,
    mobile: origin.mobile,
    isMobilePhone: origin.is_mobile,
    districtID: origin.district_id,
    address: origin.address,
    districtName: origin.district_name,
    cityName: origin.city_name,
  };
};

export const parseMonthlyFee = (origin) => {
  return {
    activityId: origin.activity_id,
    checkoutDate: origin.checkout_date,
    accountCode: origin.account_code,
    name: origin.name,
    totalShippingFee: origin.total_shipping_fee,
    upStandardDeliveryFee: origin.up_standard_delivery_fee,
    status: origin.status,
    monthlyFee: origin.monthly_fee,
    referenceCode: origin.reference_code,
    activityName: origin.activity_name,
  };
};

export const parseFeeDetail = (origin) => {
  return {
    isLocked: origin.is_locked,
    settingAll: origin.setting_all,
    memberIdList: origin.member_id_list,
    activityName: origin.activity_name,
    upStandardFee: origin.up_standard_fee,
    notUpStandardFee: origin.not_up_standard_fee,
    startDate: origin.start_date,
    endDate: origin.end_date,
  };
};
